/**
 * @description
 * 1. 签约
 * 2. 解约
 */

import { computed, ref, toRefs } from "@vue/composition-api"
import { createNamespacedHelpers } from "vuex-composition-helpers"
import * as config from "../../config"
import MUTATION_TYPES from "../../store/apple-gift-card/mutation-types"
import { AppleGiftCardActions } from "../../store/apple-gift-card/actions"
import { AppleGiftCardGetters } from "../../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../../store/apple-gift-card/mutations"
import { AppleGiftCardState, UsingLocation } from "../../store/apple-gift-card/state"
import useLocation from "../useLocation"

const { useActions, useMutations, useState, useGetters } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")
interface MaskIdProps extends Record<string, unknown> {
  init: (doModuleGetLoginState: boolean, _getLoginState?: (() => Promise<any>) | undefined) => Promise<void>
  showAppleAuth: () => void
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (props: MaskIdProps) => {
  const { toRechargePage } = useLocation()
  const { init, showAppleAuth } = toRefs(props)
  const { maskId, notSign, usingLocation, selectedCoupon, configInfo } = useState([
    "maskId",
    "notSign",
    "usingLocation",
    "selectedCoupon",
    "configInfo"
  ])
  const { reportUserAction, cancelAppleSign, setToastMsg } = useActions(["reportUserAction", "cancelAppleSign", "setToastMsg"])
  const { bannerText } = useGetters(["bannerText"])
  const mutations = useMutations([MUTATION_TYPES.SET_MASK_ID, MUTATION_TYPES.SET_NOT_SIGN])
  const isCancelSignShown = ref(false)

  const displayUnbindButton = computed(() => usingLocation.value !== UsingLocation.HOME)

  const handleBinding = () => {
    if (usingLocation.value === UsingLocation.HOME) {
      reportUserAction({
        iformat: config.REPORT.CLICK[UsingLocation.HOME].BIND
      })
      toRechargePage()
    } else {
      reportUserAction({
        iformat: config.REPORT.CLICK.BIND_SIGN
      })
      showAppleAuth.value()
    }
  }
  const cancelSign = () => {
    reportUserAction({
      iformat: config.REPORT.PAGEVIEW.UNBIND_SIGN
    })
    reportUserAction({
      iformat: config.REPORT.CLICK.UNBIND_SIGN
    })
    isCancelSignShown.value = true
  }
  const closeCancelSign = () => {
    reportUserAction({
      iformat: config.REPORT.CLICK.CANCEL_UNBIND_SIGN
    })
    isCancelSignShown.value = false
  }

  const confirmCancelSign = async () => {
    reportUserAction({
      iformat: config.REPORT.CLICK.CONFIRM_UNBIND_SIGN
    })

    try {
      await cancelAppleSign()
      mutations[MUTATION_TYPES.SET_MASK_ID]("")
      mutations[MUTATION_TYPES.SET_NOT_SIGN](true)
      /**
       * cb: init.value
       * 回调函数用于刷新当前页面的用户信息
       */
      setToastMsg({ toastMsg: "解绑成功！", cb: init.value })
      isCancelSignShown.value = false
      reportUserAction({
        iformat: config.REPORT.PAGEVIEW.UNBIND_SIGN_SUCCESS
      })
    } catch (e: any) {
      reportUserAction({
        iformat: config.REPORT.PAGEVIEW.UNBIND_SIGN_ERROR,
        resultInfo: e
      })
      if (e && e.msg && e.err_code == "") {
        setToastMsg({ toastMsg: e.msg })
      } else {
        setToastMsg({ toastMsg: "系统繁忙，请稍后再试！" })
      }
    }
  }

  const marginBottom = computed(() => {
    if (selectedCoupon.value || (bannerText.value && usingLocation.value === UsingLocation.APPLE_GIFT_CARD)) return ""
    return "0.08rem"
  })

  return {
    maskId,
    isCancelSignShown,
    notSign,
    usingLocation,
    selectedCoupon,
    configInfo,
    bannerText,
    displayUnbindButton,
    cancelSign,
    confirmCancelSign,
    closeCancelSign,
    handleBinding,
    marginBottom
  }
}
